module.exports = new __parcel__URL__("EU_EEA_UK_Switzerland.90ad35db.png").toString();